import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useCreateOp } from './useClientOps';
import { AddOpFormSchema } from '../schemas';

// Fase 5.15 (05-remediation.md) -- `AddOpModal.jsx` importaba `react-hook-form` +
// `@hookform/resolvers/zod` directo (la violación §4 más clara del slice). El formulario vive
// acá: el modal es presentacional y sólo recibe `register` / `handleSubmit` / `formState` +
// `submitOp` (ningún import de RHF, ningún `FormProvider`/`useFormContext`).
// Mantiene el comportamiento de 02.3-client.md paso b′: error visible sólo tras el primer
// intento fallido de submit (vía `formState.isSubmitted`).
export function useAddOpForm({ onSave, onClose }) {
    const form = useForm({
        resolver: zodResolver(AddOpFormSchema),
        defaultValues: {
            transaction: '', client_id: '', oper_id: '',
            amount: '', currency: 'MXN', price: '',
            cost: '', price_amount: '',
            operation_time: '', category: 'todos', status: 'PLANEADO',
        },
    });
    const createOpMutation = useCreateOp();

    // `submitOp(spaceId)` -> devuelve el handler de submit ya ligado al `spaceId` elegido en el
    // selector (que no es un campo validado del form, tiene su propio `useState` en el modal).
    const submitOp = (spaceId) => form.handleSubmit(async (values) => {
        // 2026-07-14: manda el space activo (o el elegido) para que `opsAccess.canCommentOnOp`
        // pueda autorizar a cualquier miembro del space.
        const d = await createOpMutation.mutateAsync({ ...values, space_id: spaceId ?? null });
        if (d.op) onSave();
        onClose();
    });

    return { register: form.register, formState: form.formState, submitOp };
}
